import { Component, OnInit } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { TradeVoucherComponent } from "@modules/trade/modals/trade-voucher-modal/trade-voucher.component";
import { VoucherOffer } from "@models/voucher_offer";

@Component({
	selector: "trade-voucher-dialog",
	template: "",
	standalone: false
})
export class TradeVoucherDialogComponent implements OnInit {
	constructor(private modalService: ModalService) {}

	public ngOnInit(): void {
		this.modalService.create(TradeVoucherComponent, { data: new VoucherOffer() }).present();
	}
}
